import React, { useEffect, useState } from 'react';
import Footer from '../components/Footer';
import SecondNav from '../components/SecondNav';
import { useParams } from 'react-router';
import axios from 'axios';
import ApplyForm from '../components/ApplyNow';
import '../assets/css/Local.css'

const LocaljobView = () => {
  const { id } = useParams();
  const [Job, setLJob] = useState(null);

  const getData = () => {
    axios.get(`https://api.myskills.lk/ljobs/getone/${id}`).then((response) => {
      console.log(response.data[0]);
      setLJob(response.data[0]);
    }).catch((err) => {
      console.log(err);
    });
  };

  useEffect(() => {
    getData();
  }, [id]);


  if (!Job) {
    return <p>Loading...</p>;
  }

  const handleEmail = () => {
    window.location.href = `mailto:${Job.email}?subject=Apply for the job`;
  };

  return (
    <div>
      <SecondNav />

      <div className="content-local-job">

        <div className="local-job-view-1">

          <div className="image-in-local">
            {Job.img && <img src={`https://api.myskills.lk/Upload/images/${Job.img}`} alt='' width={550}/>}
          </div>

          <div className="text-local-all">

            <div className="local-row01">

              <div>

                <p id='test-head'><i className="fa-solid fa-at"></i>{Job.jobtit}</p>

                <div className="text-marge">
                  <p id='test-head-post'>Posted by {Job.cname}</p>
                  <p id='test-head-post'> {Job.cdate}</p>
                </div>

                <div className="test-loacl-details">

                  <div className="contect-wrap-1-local">

                    <div className="contect-1-local">
                      <p id='text-seen'>Job Type</p>
                      <p id="send-marge-local">{Job.jobtype}</p>
                    </div>

                    <div className="contect-1-local">
                      <p id='text-seen'>Job Level</p>
                      <p id="send-marge-local">{Job.joblevel}</p>
                    </div>

                    <div className="contect-1-local">
                      <p id='text-seen'>Salary</p>
                      <p id="send-marge-local">{Job.salary}</p>
                    </div>

                    <div className="contect-1-local">
                      <p id='text-seen'>Close Date</p>
                      <p id="send-marge-local">{Job.cdate}</p>
                    </div>
                  </div>

                  <div className="contect-wrap-1-local">

                    <div className="contect-1-local">
                      <p id='text-seen'>Company Name</p>
                      <p id="send-marge-local">{Job.jobtype}</p>
                    </div>


                    <div className="contect-1-local">
                      <p id='text-seen'>Contact</p>
                      <p id="send-marge-local">{Job.contact}</p>
                    </div>

                    <div className="contect-1-local">
                      <p id='text-seen'>Email</p>
                      <p id="send-marge-local">{Job.email}</p>
                    </div>

                    <div className="contect-1-local">
                      <p id='text-seen'>Company Web</p>
                      <p id="send-marge-local">{Job.web}</p>
                    </div>

                    <div className="contect-1-local">
                      <p id='text-seen'>Company Address</p>
                      <p id="send-marge-local">{Job.caddr}</p>
                    </div>
                  </div>

                </div>

                <div className="contect-wrap-1-local">

                  <div className="contect-1-local">
                    <p id='text-seen'>About Jon</p>
                    <p id="send-marge-local">{Job._desc}</p>
                  </div>
                </div>


              </div>

            </div>

          </div>
        </div>
        <div className="programme" style={{display: 'flex', justifyContent: 'center', marginTop: '2rem'}}>
          <ApplyForm/>
        </div>


        {/*<div className="applyConLocal">*/}

        {/*  <div className="text-lo">*/}
        {/*    <h2>Apply Now</h2>*/}
        {/*    <hr id="local-app"/>*/}
        {/*  </div>*/}

        {/*  /!*<button id="button-up" onClick={handleEmail}>*!/*/}
        {/*  /!*  SEND DETAILS*!/*/}
        {/*  /!*</button>*!/*/}

        {/*  <form onSubmit={handleEmail}>*/}

        {/*    <div className="first-fjob-1">*/}
        {/*      <input type="text" placeholder='NAME' name="name" />*/}
        {/*      <input type="email" placeholder='EMAIL' name="email" />*/}
        {/*      <input type="text" placeholder='CONTACT' name="contact"/>*/}
        {/*    </div>*/}

        {/*    <div className="first-fjob-1">*/}
        {/*      <input type="text" placeholder='ADDRESS' name="addr" />*/}
        {/*      <input type="text" placeholder='PASSPOART NO' name="passno"/>*/}
        {/*    </div>*/}

        {/*    <div className="first-fjob-1">*/}
        {/*      <textarea placeholder="MESSAGE" name="mess" id="" ></textarea>*/}
        {/*    </div>*/}

        {/*    <input type="submit" id="button-up" value="Apply Now"*/}
        {/*           style={{textTransform: 'uppercase', padding: "10px"}}/>*/}


        {/*  </form>*/}

        {/*</div>*/}

      </div>


      <Footer/>
    </div>
  );
};

export default LocaljobView;
